"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_2a0m5k7043 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/LoginForm.js";
  var hash = "27a97c167d0b14344a841da0f703edd71242a3da";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/LoginForm.js",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 34
        },
        end: {
          line: 22,
          column: 46
        }
      },
      "1": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "2": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 31
        }
      },
      "3": {
        start: {
          line: 30,
          column: 25
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "4": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 20
        }
      },
      "5": {
        start: {
          line: 34,
          column: 22
        },
        end: {
          line: 34,
          column: 37
        }
      },
      "6": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      },
      "7": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 33
        }
      },
      "8": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 30
        }
      },
      "9": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 27
        }
      },
      "10": {
        start: {
          line: 44,
          column: 15
        },
        end: {
          line: 44,
          column: 20
        }
      },
      "11": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      "13": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 101,
          column: 4
        }
      },
      "14": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 31
        }
      },
      "15": {
        start: {
          line: 104,
          column: 0
        },
        end: {
          line: 116,
          column: 2
        }
      },
      "16": {
        start: {
          line: 118,
          column: 0
        },
        end: {
          line: 118,
          column: 58
        }
      },
      "17": {
        start: {
          line: 120,
          column: 15
        },
        end: {
          line: 147,
          column: 2
        }
      },
      "18": {
        start: {
          line: 120,
          column: 25
        },
        end: {
          line: 147,
          column: 1
        }
      },
      "19": {
        start: {
          line: 149,
          column: 25
        },
        end: {
          line: 149,
          column: 63
        }
      }
    },
    fnMap: {
      "0": {
        name: "LoginFormComponent",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 27
          }
        },
        loc: {
          start: {
            line: 21,
            column: 3
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 30,
            column: 25
          },
          end: {
            line: 30,
            column: 26
          }
        },
        loc: {
          start: {
            line: 30,
            column: 36
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 93,
            column: 19
          },
          end: {
            line: 93,
            column: 20
          }
        },
        loc: {
          start: {
            line: 93,
            column: 25
          },
          end: {
            line: 95,
            column: 11
          }
        },
        line: 93
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 120,
            column: 15
          },
          end: {
            line: 120,
            column: 16
          }
        },
        loc: {
          start: {
            line: 120,
            column: 25
          },
          end: {
            line: 147,
            column: 1
          }
        },
        line: 120
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 46,
            column: 12
          }
        }, {
          start: {
            line: 46,
            column: 16
          },
          end: {
            line: 46,
            column: 29
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 61,
            column: 46
          },
          end: {
            line: 61,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 72
          },
          end: {
            line: 61,
            column: 87
          }
        }, {
          start: {
            line: 61,
            column: 90
          },
          end: {
            line: 61,
            column: 94
          }
        }],
        line: 61
      },
      "5": {
        loc: {
          start: {
            line: 61,
            column: 46
          },
          end: {
            line: 61,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 46
          },
          end: {
            line: 61,
            column: 50
          }
        }, {
          start: {
            line: 61,
            column: 54
          },
          end: {
            line: 61,
            column: 69
          }
        }],
        line: 61
      },
      "6": {
        loc: {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 18
          },
          end: {
            line: 65,
            column: 32
          }
        }, {
          start: {
            line: 65,
            column: 35
          },
          end: {
            line: 65,
            column: 45
          }
        }],
        line: 65
      },
      "7": {
        loc: {
          start: {
            line: 67,
            column: 7
          },
          end: {
            line: 70,
            column: 30
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 70,
            column: 21
          }
        }, {
          start: {
            line: 70,
            column: 25
          },
          end: {
            line: 70,
            column: 30
          }
        }],
        line: 67
      },
      "8": {
        loc: {
          start: {
            line: 74,
            column: 42
          },
          end: {
            line: 74,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 74,
            column: 49
          },
          end: {
            line: 74,
            column: 62
          }
        }, {
          start: {
            line: 74,
            column: 65
          },
          end: {
            line: 74,
            column: 67
          }
        }],
        line: 74
      },
      "9": {
        loc: {
          start: {
            line: 79,
            column: 42
          },
          end: {
            line: 79,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 49
          },
          end: {
            line: 79,
            column: 62
          }
        }, {
          start: {
            line: 79,
            column: 65
          },
          end: {
            line: 79,
            column: 67
          }
        }],
        line: 79
      },
      "10": {
        loc: {
          start: {
            line: 90,
            column: 27
          },
          end: {
            line: 90,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 90,
            column: 34
          },
          end: {
            line: 90,
            column: 49
          }
        }, {
          start: {
            line: 90,
            column: 52
          },
          end: {
            line: 90,
            column: 67
          }
        }],
        line: 90
      },
      "11": {
        loc: {
          start: {
            line: 91,
            column: 17
          },
          end: {
            line: 91,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 26
          },
          end: {
            line: 91,
            column: 37
          }
        }, {
          start: {
            line: 91,
            column: 40
          },
          end: {
            line: 91,
            column: 49
          }
        }],
        line: 91
      },
      "12": {
        loc: {
          start: {
            line: 96,
            column: 11
          },
          end: {
            line: 96,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 28
          }
        }, {
          start: {
            line: 96,
            column: 31
          },
          end: {
            line: 96,
            column: 41
          }
        }],
        line: 96
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "27a97c167d0b14344a841da0f703edd71242a3da"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function LoginFormComponent(_ref) {
  var config = _ref.config,
      classes = _ref.classes,
      authentication = _ref.authentication,
      actionText = _ref.actionText,
      errorText = _ref.errorText,
      onSubmit = _ref.onSubmit;
  cov_2a0m5k7043.f[0]++;

  var _ref2 = (cov_2a0m5k7043.s[0]++, (0, _react.useState)({})),
      _ref3 = _slicedToArray(_ref2, 2),
      formData = _ref3[0],
      setFormData = _ref3[1];

  var user;
  cov_2a0m5k7043.s[1]++;

  if (authentication) {
    cov_2a0m5k7043.b[0][0]++;
    cov_2a0m5k7043.s[2]++;
    user = authentication.user;
  } else {
    cov_2a0m5k7043.b[0][1]++;
  }

  cov_2a0m5k7043.s[3]++;

  var updateFormData = function updateFormData(event) {
    cov_2a0m5k7043.f[1]++;

    var _ref4 = (cov_2a0m5k7043.s[4]++, event.target),
        type = _ref4.type,
        name = _ref4.name,
        value = _ref4.value,
        checked = _ref4.checked;

    var _formData = (cov_2a0m5k7043.s[5]++, _objectSpread({}, formData));

    cov_2a0m5k7043.s[6]++;

    if (type === 'checkbox') {
      cov_2a0m5k7043.b[1][0]++;
      cov_2a0m5k7043.s[7]++;
      _formData[value] = checked;
    } else {
      cov_2a0m5k7043.b[1][1]++;
      cov_2a0m5k7043.s[8]++;
      _formData[name] = value;
    }

    cov_2a0m5k7043.s[9]++;
    setFormData(_formData);
  };

  var footer = (cov_2a0m5k7043.s[10]++, _react.default.createElement(_react.default.Fragment, null));
  cov_2a0m5k7043.s[11]++;

  if ((cov_2a0m5k7043.b[3][0]++, config) && (cov_2a0m5k7043.b[3][1]++, config.server)) {
    cov_2a0m5k7043.b[2][0]++;
    cov_2a0m5k7043.s[12]++;
    footer = _react.default.createElement("div", {
      className: classes.footer_container
    }, _react.default.createElement("div", {
      className: classes.footer_column
    }, _react.default.createElement(_core.Typography, {
      variant: "caption"
    }, "Need an account?\xA0"), _react.default.createElement(_core.Typography, {
      color: "primary",
      variant: "caption",
      component: "a",
      target: "_blank",
      href: "".concat(config.server, "/user/sign_up")
    }, "Register now.")), _react.default.createElement("div", {
      className: classes.footer_column
    }, _react.default.createElement(_core.Typography, {
      color: "primary",
      variant: "caption",
      component: "a",
      target: "_blank",
      href: "".concat(config.server, "/user/forgot_password")
    }, "Forgot password?")));
  } else {
    cov_2a0m5k7043.b[2][1]++;
  }

  cov_2a0m5k7043.s[13]++;
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    src: (cov_2a0m5k7043.b[5][0]++, user) && (cov_2a0m5k7043.b[5][1]++, user.avatar_url) ? (cov_2a0m5k7043.b[4][0]++, user.avatar_url) : (cov_2a0m5k7043.b[4][1]++, null)
  }, _react.default.createElement(_icons.LockOutlined, null)), _react.default.createElement(_core.Typography, {
    component: "h1",
    variant: "h5"
  }, user ? (cov_2a0m5k7043.b[6][0]++, user.full_name) : (cov_2a0m5k7043.b[6][1]++, actionText)), errorText ? (cov_2a0m5k7043.b[7][0]++, _react.default.createElement(_core.Typography, {
    "data-test": "login-error-text",
    component: "p",
    style: {
      color: 'red'
    }
  }, errorText)) : (cov_2a0m5k7043.b[7][1]++, _react.default.createElement(_react.default.Fragment, null)), _react.default.createElement("form", {
    className: classes.form
  }, _react.default.createElement(_core.TextField, {
    "data-test": "username-input",
    name: "username",
    type: "text",
    label: "Username",
    required: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    autoComplete: "username",
    disabled: !!user,
    defaultValue: user ? (cov_2a0m5k7043.b[8][0]++, user.username) : (cov_2a0m5k7043.b[8][1]++, ''),
    onChange: updateFormData
  }), _react.default.createElement(_core.TextField, {
    "data-test": "password-input",
    name: "password",
    type: "password",
    label: "Password",
    required: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    autoComplete: "current-password",
    disabled: !!user,
    defaultValue: user ? (cov_2a0m5k7043.b[9][0]++, user.username) : (cov_2a0m5k7043.b[9][1]++, ''),
    onChange: updateFormData
  }), _react.default.createElement(_core.FormControlLabel, {
    "data-test": "remember-checkbox",
    label: "Remember me",
    control: _react.default.createElement(_core.Checkbox, {
      color: "primary",
      value: "remember",
      disabled: !!user,
      id: 'remember-' + Math.random(),
      onChange: updateFormData
    })
  }), _react.default.createElement(_core.Button, {
    "data-test": user ? (cov_2a0m5k7043.b[10][0]++, 'logout-button') : (cov_2a0m5k7043.b[10][1]++, 'submit-button'),
    type: "button",
    fullWidth: true,
    variant: "contained",
    color: user ? (cov_2a0m5k7043.b[11][0]++, 'secondary') : (cov_2a0m5k7043.b[11][1]++, 'primary'),
    className: classes.submit,
    onClick: function onClick() {
      cov_2a0m5k7043.f[2]++;
      cov_2a0m5k7043.s[14]++;
      onSubmit(formData);
    }
  }, user ? (cov_2a0m5k7043.b[12][0]++, 'Logout') : (cov_2a0m5k7043.b[12][1]++, actionText)), footer));
}

cov_2a0m5k7043.s[15]++;
LoginFormComponent.propTypes = {
  /** Configuration to use for sign up/forgot password flow */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  }),
  classes: _propTypes.default.object.isRequired,

  /** Callback function to propogate the username and password entered. */
  onSubmit: _propTypes.default.func.isRequired,

  /** The text to describe the action of logging in. */
  actionText: _propTypes.default.string,

  /** The text to describe the error when Authentication fails. */
  errorText: _propTypes.default.string,

  /** The authenticated user object */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object
  })
};
cov_2a0m5k7043.s[16]++;
LoginFormComponent.defaultProps = {
  actionText: 'Login'
};
cov_2a0m5k7043.s[17]++;

var styles = function styles(theme) {
  cov_2a0m5k7043.f[3]++;
  cov_2a0m5k7043.s[18]++;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: "".concat(theme.spacing.unit * 2, "px ").concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px")
    },
    avatar: {
      margin: theme.spacing.unit,
      backgroundColor: theme.palette.primary.main
    },
    form: {
      width: '100%',
      // Fix IE 11 issue.
      marginTop: theme.spacing.unit
    },
    submit: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit * 2
    },
    footer_container: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    footer_column: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  };
};

var LoginForm = (cov_2a0m5k7043.s[19]++, (0, _withStyles.default)(styles)(LoginFormComponent));
exports.LoginForm = LoginForm;